(function (app, ng) {

    app.directive("equalColumnWidth",
        [
            "$timeout", function ($timeout) {
                return {
                    restrict: "A",
                    link: function (scope, element) {
                        var elem = element[0];

                        function setColumnWidths() {
                            var headerCells = elem.getElementsByTagName("th");
                            var columns = [];

                            ng.forEach(headerCells,
                                function(cell, index) {
                                    columns[index] = [cell];
                                });

                            var tbody = elem.getElementsByTagName("tbody")[0];
                            var bodyRows = tbody.getElementsByTagName("tr");

                            ng.forEach(bodyRows,
                                function(row) {
                                    var cells = row.getElementsByTagName("td");

                                    ng.forEach(cells,
                                        function(cell, index) {
                                            columns[index].push(cell);
                                        });
                                });

                            var maxWidths = new Array(columns.length);
                            ng.forEach(columns,
                                function(column, index) {
                                    if (!maxWidths[index]) {
                                        maxWidths[index] = Math.max.apply(null,
                                            column.map(function(cell) {
                                                cell = ng.element(cell);
                                                return cell.width();
                                            }));
                                    }

                                    ng.forEach(column,
                                        function(cell) {
                                            var c = ng.element(cell);

                                            if (maxWidths[index] > 550) {
                                                c.css("min-width", 550);
                                                c.css("max-width", 550);
                                                c.css("word-break", "break-word");
                                            } else {
                                                c.css("min-width", maxWidths[index]);
                                            }

                                        });
                                });
                        }

                        $timeout(function () {
                            setColumnWidths();
                        },
                            0);
                    }
                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line